import { GoogleLogin } from '@react-oauth/google'
import { useDispatch } from 'react-redux'

import useAuth from './useAuth'

import { parseUserInfo } from '../../utils'

const GoogleLoginWithAlivecorEmail = ({onSuccess, onError}) => {
    const dispatch = useDispatch()
    // login action
    const { login } = useAuth()

    const handleSuccess = (token) => {
        const credential = token?.credential

        if (!credential) {
            onError(new Error('Missing credential in Google response'))
            return
        }

        const userInfo = parseUserInfo(credential)
        if (!userInfo) {
            onError(new Error('Failed to parse user info from credential'))
            return
        }

        window.localStorage.setItem('usr', JSON.stringify(userInfo))
        dispatch(login(userInfo))
        onSuccess(userInfo)
    }

    return (
        <GoogleLogin
            onSuccess={handleSuccess}
            onError={onError}
        />
    )
}

export default GoogleLoginWithAlivecorEmail;